import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'

interface PartiallyApprovedViewProps {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint?: () => void

}

const PartiallyApprovedView: React.FC<PartiallyApprovedViewProps> = ({ data, tableRows, highlightedDates, handlePrint }) => (
  <div>
    <h1 className="h1">Time Off Request Partially Retraction Approved</h1>
    <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row">
      <div className="flex-1">
        {(data.retractionApprovedOn ?? data.approvedOn) && (
          <div className="mb-4">
            <LabeledValue label="Retraction Approved On" value={data.retractionApprovedOn ?? data.approvedOn ?? ''} />
          </div>
        )}
        {data.authorizedApprover && <div className="mb-4"><LabeledValue label="Authorized Approver" value={data.authorizedApprover} /></div>}
        {(data.requestRank != null || isVacationBid(data)) && <div className="mb-4"><LabeledValue label="Request Rank" value={data.requestRank == null ? 'NA' : String(data.requestRank)} /></div>}
        {data.approvalReason && <div className="mb-4"><LabeledValue label="Approval Reason" value={data.approvalReason} /></div>}
        {data.approverComments && <div className="mb-4"><LabeledValue label="Approver Comments" value={data.approverComments} /></div>}
      </div>
      <RightPanel data={data} handlePrint={handlePrint} />
    </div>
    <div className="mt-6!"><hr className="-variation-1" /></div>
    <div className="w-full mt-6">
      <h2 className="h2">History</h2>
      {data.submittedOn && <div className="mb-4"><LabeledValue label="Retraction Submitted On" value={data.submittedOn} /></div>}
      {data.submittedBy && <div className="mb-4"><LabeledValue label="Submitted By" value={data.submittedBy} /></div>}
      {data.employeeRetractionComment && (
        <div className="mb-4">
          <LabeledValue label="Employee Comments Regarding Retraction" value={data.employeeRetractionComment} />
        </div>
      )}
      {data.approvedOn && <div className="mb-4"><LabeledValue label="Partially Approved On" value={data.approvedOn} /></div>}
      {data.originalRequestId && <div className="mb-4"><LabeledValue label="Approved Time Off Request ID" value={data.originalRequestId} /></div>}
      {data.returnedBy && <div className="mb-4"><LabeledValue label="Returned By" value={data.returnedBy} /></div>}
      {data.approverComments && <div className="mb-4"><LabeledValue label="Approver Comments" value={data.approverComments} /></div>}
    </div>
    {data.history && data.history.length > 0 && <HistorySection history={data.history} />}
    <CurrentRequestSection {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))} highlightedDates={highlightedDates} />
  </div>
)

export default PartiallyApprovedView
